import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../../../../../generic/ui/check-box/Checkbox';
import { AccentButton } from '../../../../../../generic/ui/Button';
import { FormField, FormFooter } from '../../../../../../generic/ui/FormLayout';
import { IArizotLine } from '../../../../../../modules/API/Packages/models/arizotLine';
import PackagesPickList, { IPackRow } from './PackagesPickList';

interface Props {
    list: IArizotLine[];
    /** Правит QtyTeuda, а не Qty — заказанное количество остаётся нетронутым. */
    editFunc: (qty: number, id: string) => void;
    saveFunc: (sendMail: boolean) => void;
}

const TeudaCreatePanel: React.FC<Props> = ({ list, editFunc, saveFunc }) => {
    const [t] = useTranslation(['packageOrder', 'buttons']);
    const [isSendEmail, setIsSendEmail] = useState<boolean>(true);

    const rows: IPackRow[] = list.map((line) => ({
        id: line.id ?? `${line.PackID}`,
        name: line.Description?.trim() ?? '',
        type: line.Pack_Pallet ?? '',
        qty: line.QtyTeuda ?? 0,
        remark: line.Remark,
    }));

    return (
        <Panel>
            <PackagesPickList rows={rows} onQtyChange={editFunc} />

            <FormField label='שליחת דוא"ל'>
                <Checkbox checked={isSendEmail} onChange={setIsSendEmail} />
            </FormField>

            <FormFooter>
                <AccentButton type='button' onClick={() => saveFunc(isSendEmail)} fullWidth={false}>
                    {t('buttons:save')}
                </AccentButton>
            </FormFooter>
        </Panel>
    );
};

export default TeudaCreatePanel;

const Panel = styled.div`
    width: 100%;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    direction: rtl;
`;
